/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Typed from 'typed.js';
import './typed.css'

const TypedText = ({ messages }) => {
  const [completedMessages, setCompletedMessages] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const typedElement = useRef(null);

  useEffect(() => {
    if (currentMessageIndex < messages.length) {
      const options = {
        strings: [messages[currentMessageIndex]],
        typeSpeed: 30,
        showCursor: false,
        loop: false,
        onComplete: () => {
          setCompletedMessages((prev) => [
            ...prev,
            messages[currentMessageIndex],
          ]);
          setCurrentMessageIndex((prev) => prev + 1);
        },
      };

      const typed = new Typed(typedElement.current, options);

      return () => {
        typed.destroy();
      };
    }
  }, [currentMessageIndex, messages]);

  return (
    <div>
      {completedMessages.map((msg, index) =>
        index === 0 ? (
          <h1 key={index} style={{marginBottom:'20px'}}>{msg}</h1> // Render the first message as an H1
        ) : (
          <h2 key={index}>{msg}</h2>   // Render subsequent messages as paragraphs
        )
      )}
      {currentMessageIndex < messages.length && (
        currentMessageIndex === 0 ? (
          <h1><span ref={typedElement}></span></h1> // Render the currently typing first message as H1
        ) : (
          <h2><span ref={typedElement}></span></h2>   // Render subsequent currently typing messages as paragraphs
        )
      )}
    </div>
  );
};

export default TypedText;
